import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = (): React.ReactElement => {
  return (
    <div className="three-dots-spinner">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );
};

export default LoadingSpinner;
